import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Combokeys from 'combokeys'
import { Effects } from 'dbrain-web-ui-lib'
import { idx2color, isTouchDevice } from 'Utils/common'
import Core from './core'
import { collectUniqIdxes } from '../../api'
import AssignmentResult from '../../assignmentResult'
import './style'

const fix = x => Math.min(Math.max(0, x), 1)
const maxInnerFullscreenSize = 90000

class Aabb extends Component {
	constructor(props) {
		super(props)
		this.state = {
			rects: {},
			idx: null,
			category: null,
			existedIdxes: [],
			marksError: false,
			coreError: false,
			isFullscreen: false,
			isMouseDown: false,
			innerFullscreenSize: { width: maxInnerFullscreenSize, height: maxInnerFullscreenSize },
			imageFullscreenSize: { width: 'auto', height: 'auto' },
			fullscreenOffsetLeft: 0,
			fullscreenOffsetTop: 0,
			zoomRatioPercentage: 1,
		}

		this.imageRef = React.createRef()
		this.coreMiddleRef = React.createRef()
		this.combokeys = new Combokeys(document.documentElement)
	}

	componentWillMount() {
		const { values } = this.props.task.payload

		if (values.length === 1) {
			this.handleChooseCategory(1, values[0].value)
		} else {
			this.bindComboKeys(values)
		}
	}

	componentWillReceiveProps(nextProps) {
		const { values } = nextProps.task.payload

		if (this.props.task.id !== nextProps.task.id) {
			this.bindComboKeys(values)
			this.setRects(nextProps.task.userData)
			this.setState({ existedIdxes: [] })
		}

		if (this.state.isFullscreen) {
			this.changeZoomRatio(1)
		}

		if (values.length === 1) {
			this.setState({ idx: 1, category: values[0].value })
		}

		if (nextProps.isFirstDescriptionShow) {
			this.setState({ isFullscreen: false })
		}

		if (!this.props.isNeedToShowTaskResults && nextProps.isNeedToShowTaskResults) {
			this.combokeys.reset()
		}
	}

	componentWillUnmount() {
		this.combokeys.detach()
	}

	setRects(rects) {
		this.setState({ rects: rects || {}, category: null, idx: null })
	}

	bindComboKeys(values) {
		values.forEach((value, i) => {
			const idx = i + 1
			const key = idx.toString()
			this.combokeys.bind(key, () => {
				this.handleChooseCategory(key, value.value)
			})
		})
	}

	handleChooseCategory(newIndex, newCategory) {
		const { idx, category } = this.state
		const o = {}
		const newIdx = parseInt(newIndex, 10)

		if (newIdx === idx && newCategory === category) {
			o.idx = null
			o.category = null
		} else {
			o.idx = newIdx
			o.category = newCategory
		}

		this.setState({ ...o })
	}

	handleMark(type, _rects) {
		const rects = _rects || this.state.rects
		const { category } = this.state
		const { task } = this.props
		const payload = {}


		if (type === 'complete' && Object.keys(rects).length === 0) {
			if (category) {
				this.setState({ coreError: true })
			} else {
				this.setState({ marksError: true })
			}

			return
		}

		if (type === 'noobjects' && Object.keys(this.state.rects).length !== 0) {
			this.setState({ marksError: true })
			return
		}

		task.payload.values.forEach((item) => {
			payload[item.value] = []
		})

		Object.keys(rects).forEach((key) => {
			const r = rects[key]
			const { label } = r
			const x0 = fix(r.rx)
			const y0 = fix(r.ry)
			const x1 = fix(r.rx + r.rwidth)
			const y1 = fix(r.ry + r.rheight)
			const coordinates = [
				[x0, y0],
				[x1, y0],
				[x1, y1],
				[x0, y1],
				[x0, y0],
			]
			payload[label].push(coordinates)
		})

		this.setState({ idx: null, category: null })
		this.props.markTask(payload, rects, task.type)
	}

	handleRectsUpdate(rects) {
		const existedIdxes = rects ? collectUniqIdxes(rects) : []
		this.setState({ rects, existedIdxes })
	}

	clearPaths() {
		const rects = {}
		const existedIdxes = []
		this.setState({ rects, existedIdxes })
	}

	mouseDownHandler(isMouseDown) {
		if (isMouseDown !== this.state.isMouseDown) {
			this.setState({ isMouseDown })
		}
	}

	handleZoomChange(ratio, callback) {
		const innerFullscreenSize = {}
		const imageFullscreenSize = {}

		let fullscreenOffsetLeft = 0
		let fullscreenOffsetTop = 0

		if (this.state.isFullscreen) {
			const { offsetWidth, offsetHeight } = document.body
			const { current } = this.imageRef

			const currentWidth = (current.naturalWidth || current.offsetWidth) * ratio
			const currentHeight = (current.naturalHeight || current.offsetHeight) * ratio

			innerFullscreenSize.width = offsetWidth + currentWidth
			innerFullscreenSize.height = offsetHeight + currentHeight
			fullscreenOffsetLeft = currentWidth / 2
			fullscreenOffsetTop = currentHeight / 2
			imageFullscreenSize.width = currentWidth
			imageFullscreenSize.height = currentHeight
		} else {
			innerFullscreenSize.width = maxInnerFullscreenSize
			innerFullscreenSize.height = maxInnerFullscreenSize
		}

		this.setState({
			innerFullscreenSize,
			imageFullscreenSize,
		}, () => {
			if (callback) callback()

			this.setState({
				fullscreenOffsetLeft,
				fullscreenOffsetTop,
			})
		})
	}

	handleButtonToggleFullscreen(zoomRatioPercentage, fullscreenCallback) {
		this.setState(prev => ({
			isFullscreen: !prev.isFullscreen,
			zoomRatioPercentage,
		}), () => {
			this.handleZoomChange(zoomRatioPercentage, fullscreenCallback)
		})
	}

	changeZoomRatio(zoomRatioPercentage, callback) {
		this.setState({ zoomRatioPercentage }, () => {
			this.handleZoomChange(zoomRatioPercentage, callback)
		})
	}

	generateMarkupButtons() {
		const { isMarkButtonInCaption, isNeedToShowTaskResults } = this.props
		const { values } = this.props.task.payload

		if (isMarkButtonInCaption) {
			return ''
		}

		const { category } = this.state

		const buttons = values.map((item, i) => {
			const idx = i + 1
			const existsClassName = this.state.existedIdxes.includes(idx) ? 'exists' : ''
			const pressedClassName = item.value === category ? 'pressed' : ''
			const text = isTouchDevice() ? item.text : `${idx}. ${item.text}`

			return (
				<span
					role="button"
					tabIndex="0"
					key={idx}
					disabled={isNeedToShowTaskResults}
					className={`${existsClassName} ${pressedClassName} btn btn-gray rainbow`}
					onClick={() => this.handleChooseCategory(idx, item.value)}
				>
					{text}
				</span>
			)
		})

		return (
			<Effects
				transition="shakeShort"
				transitionFinish={() => { this.setState({ marksError: false }) }}
				init={this.state.marksError}
			>
				<div className="buttons marks">
					{buttons}
				</div>
			</Effects>
		)
	}

	render() {
		const {
			rects,
			category,
			isFullscreen,
			isMouseDown,
		} = this.state

		const {
			task,
			testLabel,
			caption,
			description,
			fullDescriptionPopup,
			isNeedToShowTaskResults,
			comparedResult,
			nextTask,
			rightScoreThreshold,
			currentTaskCaption,
		} = this.props

		const outerButtonDownClassName = isFullscreen && isMouseDown && category ? 'hide' : ''

		const bottomButtons = isNeedToShowTaskResults
			? (
				<div className="buttons taskresult">
					<AssignmentResult isRight={comparedResult.score >= rightScoreThreshold[task.type]} />

					<span
						className="taskresult-next btn"
						role="button"
						tabIndex="0"
						onClick={nextTask}
					>
						Next
					</span>
				</div>
			)
			: (
				<div className="buttons">
					<span
						role="button"
						tabIndex="0"
						className="btn btn-gray"
						onClick={() => this.handleMark('complete')}
					>
						Complete
					</span>
					<span
						role="button"
						tabIndex="0"
						className="btn-border"
						onClick={() => this.handleMark('noobjects', {})}
					>
						No objects
					</span>
				</div>
			)

		const bboxes = (
			<div className="core-wrapper">
				<Effects
					transition="shakeShort"
					transitionFinish={() => { this.setState({ coreError: false }) }}
					init={this.state.coreError}
				>
					<Core
						container="svg_container"
						imageUrl={task.payload.image}
						imageRef={this.imageRef}
						coreMiddleRef={this.coreMiddleRef}
						onRectsUpdate={this.handleRectsUpdate.bind(this)}
						minBoxSide={24}
						clearPaths={this.clearPaths.bind(this)}
						label={category}
						idx={this.state.idx}
						rectStyle={this.state.idx === null ? {} : idx2color(this.state.idx - 1)}
						rects={rects}
						isNeedToShowTaskResults={isNeedToShowTaskResults}
						comparedResult={comparedResult}
						isFullscreen={isFullscreen}
						innerFullscreenSize={this.state.innerFullscreenSize}
						imageFullscreenSize={this.state.imageFullscreenSize}
						mouseDownHandler={this.mouseDownHandler.bind(this)}
						handleButtonToggleFullscreen={this.handleButtonToggleFullscreen.bind(this)}
						fullscreenOffsetLeft={this.state.fullscreenOffsetLeft}
						fullscreenOffsetTop={this.state.fullscreenOffsetTop}
						zoomRatioPercentage={this.state.zoomRatioPercentage}
						changeZoomRatio={this.changeZoomRatio.bind(this)}
						isMarkButtonInCaption={this.props.isMarkButtonInCaption}
					/>
				</Effects>
			</div>
		)

		const annotationFullscreenClassName = isFullscreen ? 'annotation-fullscreen' : ''

		return (
			<React.Fragment>
				<div className={`annotation row ${annotationFullscreenClassName}`}>
					<div className="image col-4 col-sm-4 col-xs-2">
						{bboxes}
					</div>

					<div className="actions col-2 col-sm-4 col-xs-2">
						<div className="actions-inner">
							{testLabel}
							<div className="gap-back sm-hidden" />
							{currentTaskCaption}
							{caption}
							{description}
							<div className="gap-back sm-hidden" />

							<div className={`buttons-outer ${outerButtonDownClassName}`}>
								{this.generateMarkupButtons()}

								{bottomButtons}
							</div>
						</div>
					</div>
				</div>
				{fullDescriptionPopup}
			</React.Fragment>
		)
	}
}
Aabb.defaultProps = {
	testLabel: null,
	caption: null,
	description: null,
	comparedResult: {},
}
Aabb.propTypes = {
	markTask: PropTypes.func.isRequired,
	task: PropTypes.object.isRequired,
	testLabel: PropTypes.node,
	caption: PropTypes.node,
	currentTaskCaption: PropTypes.node.isRequired,
	description: PropTypes.node,
	isMarkButtonInCaption: PropTypes.bool.isRequired,
	fullDescriptionPopup: PropTypes.node.isRequired,
	isFirstDescriptionShow: PropTypes.bool.isRequired,
	isNeedToShowTaskResults: PropTypes.bool.isRequired,
	comparedResult: PropTypes.object,
	nextTask: PropTypes.func.isRequired,
	rightScoreThreshold: PropTypes.object.isRequired,
}
export default Aabb
